import { Component, Input, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { CalendarService } from '../../../services/calendar.service';
import { AuthService, TranslatorService } from '../../../services';

@Component({
    selector: 'sn-usc-monthly-sales-panel',
    templateUrl: './usc-monthly-sales-panel.component.html',
    styleUrls: ['./usc-monthly-sales-panel.component.css']
})
export class UscMonthlySalesPanelComponent implements OnInit {
    @Input() sales_mode: string;
    @Input() scope_type: string;
    @Input() scope_value: string;
    @Input() scope_user: any;
    @Input() scope_month: string;

    public p2w_goal_exceeded:number = 0;
    public p2w_quota_exceeded:number = 0;
    public days_remaining:number;
    public action_plan: any;
    public isLeader: boolean;
    public isStoreTeam: boolean = false;
    public isSalesVsQuota: boolean = false;
    public isSalesVsGoal: boolean = false;
    public is_action_plan_loaded: boolean = false;
    public is_action_plan_unavailable: boolean = false;
    public isConsultant: boolean = false;
    public is_current_month: boolean = true;
    //public current_month: string = "";
    public current_user: any = null;
    scope_achievement:any;
    public is_other_results_enabled: boolean = true;

    public total_estimated_payout:number;
    public total_pacing_payout:number;
    
    drivers: any[] = [
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "postpaid", label: "Postpaid" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "other_volume", label: "Other Volume" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "revenue", label: "Revenue" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "upgrades", label: "Upgrades" },
        { mtd: 0, quota: 0, mtd_quota_pct: "0", incentive: 0, incentive_earned: 0, kicker_value: 0, kicker_earned: 0, payout: 0, driver: "high_msrp_accessories", label: "High MSRP Accessories",},
    ];

    constructor(
        public uscStoreService: UscStoreService,
        public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public authService: AuthService,
    ) {
        this.isLeader = this.uscStoreService.isLeader();
        this.current_user = this.authService.getActive();
        // consultant view (scope_type is null)
        if (this.scope_type != 'user') {
            if (!this.isLeader) {
                if (this.is_current_month) 
                this.uscStoreService.getThisMonthActionPlans().subscribe(result => {
                    this.action_plan = result;
                    this.analyzeActionPlan();
                    this.is_action_plan_loaded = true;
                })
            }
        }
    }

    ngOnInit() {
        this.is_other_results_enabled = this.uscStoreService.is2022Q4Phase3Enabled();
        if (this.scope_month == undefined) this.scope_month = this.uscStoreService.getThisMonthActionPlanSubject();
        this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
        this.isStoreTeam = this.scope_type == "store";
        this.isConsultant = this.scope_type == "user";
        this.isSalesVsQuota = this.isLeader && this.sales_mode == 'quota';
        this.isSalesVsGoal = this.isLeader && this.sales_mode == 'goal';
        this.is_action_plan_loaded = false;

        this.updateMonthlySales();

        this.uscStoreService.p2wScopeMonth.subscribe(m => {
            if (m.length == 6 && this.scope_month != m) {
                this.scope_month = m;
                this.is_current_month = this.scope_month == this.uscStoreService.getThisMonthActionPlanSubject();
                this.sales_mode = this.uscStoreService.getCurrentView() == this.uscStoreService.view_p2w_plan_2_win ? "goal" : "quota";
                this.is_action_plan_unavailable = false;
                this.is_action_plan_loaded = false;
                this.updateMonthlySales();
            }
        })
    }

    updateMonthlySales() {
        if (this.scope_type == null) {
            if (!this.isLeader) {
                if (this.is_current_month) {
                    this.uscStoreService.getThisMonthActionPlans().subscribe(result => {
                        this.action_plan = result;
                        this.analyzeActionPlan();
                        this.is_action_plan_loaded = true;
                    })
                } else {
                    this.action_plan = this.uscStoreService.getPreviousUserActionPlanByMonth(this.current_user, this.scope_month);
                    if (this.action_plan) {
                        this.analyzeActionPlan();
                        this.is_action_plan_loaded = true;
                    } else {
                        this.is_action_plan_unavailable = true;
                    }
                }
            }
        }
        else {
            if (this.scope_type == 'user') {
                this.is_action_plan_loaded = false;
                if (this.is_current_month) {
                    this.uscStoreService.getActionPlan(this.scope_user.view_ID).subscribe(result => {
                        this.action_plan = result.item;
                        if (this.action_plan) {
                            this.analyzeActionPlan();
                            this.is_action_plan_loaded = true;
                        } else {
                            this.is_action_plan_unavailable = true;
                        }
                    })
                } else {
                    if (this.scope_user.ID == null) this.scope_user.ID = this.scope_user.ur_user_ID;
                    this.action_plan = this.uscStoreService.getPreviousUserActionPlanByMonth(this.scope_user, this.scope_month);
                    if (this.action_plan) {
                        this.analyzeActionPlan();
                        this.is_action_plan_loaded = true;
                    } else {
                        this.is_action_plan_unavailable = true;
                    }
                }
            } else if (this.uscStoreService.isLeader() && this.scope_type && this.scope_value) {
                this.is_action_plan_loaded = true;
                if (this.is_current_month) {
                    if (this.sales_mode == "quota") {
                        this.scope_achievement = this.uscStoreService.getStoreSalesQuotaSummaryAchievementByScope(this.scope_type, this.scope_value);
                    } else if (this.sales_mode == "goal") {
                        this.scope_achievement = this.uscStoreService.getStoreSalesGoalAchievementByScope(this.scope_type, this.scope_value);
                    }
                } else {
                    this.scope_achievement = this.uscStoreService.getConsultantSummaryAchievementFromPreviousActionPlans(this.scope_month, this.scope_type, this.scope_value, this.sales_mode);
                }
            }            
        }
    }

    getTitle() {
        // consultant view: scope_type == null
        if (this.scope_type == null) return this.is_current_month ? "How this month is shaping up?" : "How this month shaped up.";

        var format = "_MM_ - _ST_ _SV_";
        var mm = this.is_current_month ? "This Month" : this.calendarService.getMonthName(parseInt(this.scope_month.substring(4)) - 1);
        if (this.scope_type == 'user') {
            return mm + " - " + this.scope_user.ur_associate_name;
        } else if (this.uscStoreService.isLeader()) {
            var st = this.scope_type == "channel" ? "National" : "Team";
            return format.replace("_MM_", mm).replace("_ST_", st).replace("_SV_", this.scope_value);
        }
    }

    getDesc():string {
        var progress = "", desc = "";
        // leader's member view
        if (this.scope_type == 'user') {
            if (!this.is_current_month) {
                if (this.isSalesVsQuota) return "_USER_ surpassed __QUOTAS__ of their Plan2Win quota(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) return "_USER_ surpassed __GOALS__ of their Plan2Win goal(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__GOALS__', this.p2w_goal_exceeded.toString());
            } else {
                if (this.isSalesVsQuota) progress = "_USER_ is ahead on __QUOTAS__ of their Plan2Win quota(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "_USER_ is ahead on __AHEAD__ of their Plan2Win goal(s).".replace('_USER_', this.scope_user.ur_associate_name).replace('__AHEAD__', this.p2w_goal_exceeded.toString());
            }
        } if (!this.isLeader && this.action_plan) {
            // associate view
            if (!this.is_current_month) {
                if (this.isSalesVsQuota) progress = "Congratulations, you have surpassed __QUOTAS__ of your Plan2Win goals.".replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "Congratulations, you have surpassed __GOALS__ of your Plan2Win goals.".replace('__GOALS__', this.p2w_goal_exceeded.toString());
                desc = "Here's how __MONTH__ shaped up after you've worked __DW__ of your __DS__ scheduled days this month:";
            } else {
                if (this.isSalesVsQuota) progress = "Congratulations, you are ahead on __QUOTAS__ of your Plan2Win goal(s). ".replace('__QUOTAS__', this.p2w_quota_exceeded.toString());
                if (this.isSalesVsGoal) progress = "Congratulations, you are ahead on __AHEAD__ of your Plan2Win goal(s). ".replace('__AHEAD__', this.p2w_goal_exceeded.toString());
                desc = "Here's how __MONTH__ is shaping up after you've worked __DW__ of your __DS__ scheduled days this month:";
            }
            var month = (new Date()).getMonth();
            if (!this.is_current_month) month = parseInt(this.scope_month.substring(4, 6)) - 1;
            desc = desc.replace('__MONTH__', this.calendarService.getMonthName(month)).replace('__DW__', this.action_plan.days_worked).replace('__DS__', this.action_plan.cs_days_scheduled);
        }
        if (this.isSalesVsGoal) return (this.p2w_goal_exceeded > 0)  ? progress + desc : desc;
        if (this.isSalesVsQuota) return (this.p2w_quota_exceeded > 0)  ? progress + desc : desc;
        return "";
    }

    getUnavailableDesc(): string {
        var desc = "";
        var name = this.scope_user == null ? this.current_user.first_name + ' ' + this.current_user.last_name : this.scope_user.ur_associate_name;
        if (this.is_action_plan_unavailable) desc = "Unable to retrieve current user's sales figures.".replace('_NAME_', name);
        return desc;
    }

    analyzeActionPlan() {
        this.p2w_goal_exceeded = 0;
        if (this.action_plan) {
            this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked - 1;
            // p2w goals
            if (parseInt(this.action_plan.mtd_postpaid_handset_volume) >= parseInt(this.action_plan.cs_p2w_postpaid)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_hsi) >= parseInt(this.action_plan.cs_p2w_hsi)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_prepaid) >= parseInt(this.action_plan.cs_p2w_prepaid)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_connected_devices) >= parseInt(this.action_plan.cs_p2w_connected_devices)) this.p2w_goal_exceeded++;
            // if (parseInt(this.action_plan.mtd_other_volume) >= parseInt(this.action_plan.cs_p2w_other)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_accessories_revenue) >= parseInt(this.action_plan.cs_p2w_accessories_revenue)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_other_revenue) >= parseInt(this.action_plan.cs_p2w_other_revenue)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_bir) >= parseInt(this.action_plan.cs_p2w_bir)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_upgrades) >= parseInt(this.action_plan.cs_p2w_upgrades)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_high_msrp_accessories) >= parseInt(this.action_plan.cs_p2w_high_acc)) this.p2w_goal_exceeded++;
            if (parseInt(this.action_plan.mtd_device_trade_ins) >= parseInt(this.action_plan.cs_p2w_device_trade_ins)) this.p2w_goal_exceeded++;
            // p2w quota
            if (parseInt(this.action_plan.mtd_postpaid_handset_volume) >= JSON.parse(this.action_plan.ur_quota_postpaid_handset)[this.scope_month]) this.p2w_quota_exceeded++;
            if (parseInt(this.action_plan.mtd_hsi) >= JSON.parse(this.action_plan.ur_quota_hsi)[this.scope_month]) this.p2w_quota_exceeded++;
            if (parseInt(this.action_plan.mtd_prepaid) >= JSON.parse(this.action_plan.ur_quota_prepaid)[this.scope_month]) this.p2w_quota_exceeded++; 
            if (parseInt(this.action_plan.mtd_connected_devices) >= JSON.parse(this.action_plan.ur_quota_connected_devices)[this.scope_month]) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_other_volume) >= JSON.parse(this.action_plan.ur_quota_other_volume)[this.scope_month]) this.p2w_quota_exceeded++;
            if (parseInt(this.action_plan.mtd_accessories_revenue) >= JSON.parse(this.action_plan.ur_quota_accessories_revenue)[this.scope_month]) this.p2w_quota_exceeded++; 
            if (parseInt(this.action_plan.mtd_other_revenue) >= JSON.parse(this.action_plan.ur_quota_other_revenue)[this.scope_month]) this.p2w_quota_exceeded++; 
            if (parseInt(this.action_plan.mtd_bir) >= JSON.parse(this.action_plan.ur_quota_bir)[this.scope_month]) this.p2w_quota_exceeded++; 
            // if (parseInt(this.action_plan.mtd_postpaid_handset_volume) >= parseInt(this.action_plan.ur_quota_postpaid_handset)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_hsi) >= parseInt(this.action_plan.ur_quota_hsi)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_prepaid) >= parseInt(this.action_plan.ur_quota_prepaid)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_connected_devices) >= parseInt(this.action_plan.ur_quota_connected_devices)) this.p2w_quota_exceeded++;
            // // if (parseInt(this.action_plan.mtd_other_volume) >= parseInt(this.action_plan.ur_quota_other_volume)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_accessories_revenue) >= parseInt(this.action_plan.ur_quota_accessories_revenue)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_other_revenue) >= parseInt(this.action_plan.ur_quota_other_revenue)) this.p2w_quota_exceeded++;
            // if (parseInt(this.action_plan.mtd_bir) >= parseInt(this.action_plan.ur_quota_bir)) this.p2w_quota_exceeded++;

            if (this.is_current_month) {
                if (this.uscStoreService.isUSCellCorp() || this.uscStoreService.isUSCellTelesales()) {
                    var params = { est: 'ST_Search', 'SP_ACTION_PLAN_ID': this.action_plan.cs_ID.toString() }
                    this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_table, params).subscribe(
                        result => {
                            var forecast_business_drivers = result.items;
                            this.total_estimated_payout = 0;
                            forecast_business_drivers.forEach(bd => {
                                this.total_estimated_payout += bd.estimated_payout;
                            })        
                        },
                        err => {
                            console.log(err);
                        }
                    ); 

                    this.uscStoreService.getData(this.uscStoreService.view_p2w_payout_estimator_forecast_table, params).subscribe(
                        result => {
                            var forecast_business_drivers = result.items;
                            this.total_pacing_payout = 0;
                            forecast_business_drivers.forEach(bd => {
                                this.total_pacing_payout += bd.estimated_payout;
                            })        
                        },
                        err => {
                            console.log(err);
                        }
                    );                 
                } else {
                    this.uscStoreService.getThisMonthPayoutEstimate(this.drivers, this.action_plan, this.days_remaining).subscribe(
                        result => {
                            this.total_estimated_payout = result.total_estimated_payout;
                            this.total_pacing_payout = result.total_pacing_payout;
                        }
                    )
                }
            }
        }
    }

    gotoSubTeam() {
        var prev_scope_type = this.scope_type;
        var prev_scope_value = this.scope_value;
        var next_scope_type = "";
        if (this.scope_type == "store") {
            this.uscStoreService.setP2wTeamSalesTrackerScope({ next_scope_type: "user", prev_scope_type: prev_scope_type, prev_scope_value: prev_scope_value });
        }
        else {
            // first determine the next_scope_type
            if (this.scope_type == "channel") next_scope_type = "region";
            else if (this.scope_type == "region") next_scope_type = "territory";
            else if (this.scope_type == "territory") next_scope_type = "area";
            else if (this.scope_type == "area") next_scope_type = "store";
            // next determine the actual available scope_type
            while (this.scope_achievement[next_scope_type] == '') {
                if (next_scope_type == "region") next_scope_type = "territory";
                else if (next_scope_type == "territory") next_scope_type = "area";
                else if (next_scope_type == "area") next_scope_type = "store";
            }
            this.uscStoreService.setP2wTeamSalesTrackerScope({ next_scope_type: next_scope_type, prev_scope_type: prev_scope_type, prev_scope_value: prev_scope_value });
        }
    }

    gotoBookOfBusiness() {
        //this.scope_type == undefined;
    }   
    
    gotoDetailedResults() {
        if (this.scope_type == undefined) {
            this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_associate_detailed_results);
        } else {
            var dr_view = this.isSalesVsGoal ? this.uscStoreService.view_p2w_goal_gross_adds_detail_results : this.uscStoreService.view_p2w_quota_gross_adds_detail_results;
            this.uscStoreService.setCurrentDetailResultScope({ scope_type: this.scope_type, scope_value: this.scope_value })
            this.uscStoreService.setCurrentView(dr_view);
        }
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-monthly-sales-panel/usc-monthly-sales-panel.component.ts